/* Swubie chrome on Horizon: sticky header (hide on scroll down, show on scroll up), mobile menu,
   footer menus folded on mobile. Markup: sections/swubie-header.liquid, sections/swubie-footer.liquid. */
(function () {
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var section = document.getElementById('header-group');
    var burger = document.querySelector('[data-swb-menu-toggle]');
    var menu = document.getElementById('swb-menu');

    function setMenu(open) {
      if (!burger || !menu) return;
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      menu.hidden = !open;
      document.documentElement.classList.toggle('swb-menu-open', open);
      if (open && section) section.classList.remove('is-up');
    }
    if (burger) burger.addEventListener('click', function () { setMenu(burger.getAttribute('aria-expanded') !== 'true'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
    window.addEventListener('resize', function () { if (window.innerWidth > 989) setMenu(false); });

    /* sticky: on scroll up (plain passive handler, cheap: one class toggle) */
    if (section) {
      var last = window.pageYOffset;
      window.addEventListener('scroll', function () {
        var y = window.pageYOffset;
        if (document.documentElement.classList.contains('swb-menu-open')) { last = y; return; }
        if (y > last && y > 120) section.classList.add('is-up');
        else if (y < last) section.classList.remove('is-up');
        last = y;
      }, { passive: true });
    }

    /* search: Horizon's predictive search dialog (rendered by the layout as #search-modal) */
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-swb-search]');
      if (!b) return;
      var modal = document.getElementById('search-modal');
      if (modal && typeof modal.showDialog === 'function') { e.preventDefault(); modal.showDialog(); }
      else window.location.href = '/search';
    });

    /* footer menus: open on desktop, folded on mobile */
    if (window.matchMedia('(max-width: 749px)').matches) {
      document.querySelectorAll('[data-swb-footer-menu]').forEach(function (d) { d.removeAttribute('open'); });
    }
  });
})();
